import type { RouteLocationNormalized, RouteRecordRaw, Router } from "vue-router";
import { vendorRouteName } from "./vendorRoute";

export const vendorUserRouteName = {
  //   index: "vendor-user-index",
  detail: "vendor-user-detail",
};

export const vendorUserRoute: RouteRecordRaw[] = [
  //   {
  //     path: "vendors/:vendorId/users",
  //     name: vendorUserRouteName.index,
  //     component: () => import("../presentation/views/VendorUserIndexView.vue"),
  //     meta: {
  //       title: "Vendor Users",
  //     },
  //   },
  {
    path: "/vendors/:vendorId/users/:id",
    name: vendorUserRouteName.detail,
    component: () => import("../pages/VendorUserDetailPage.vue"),
    meta: {
      requiresAuth: true,
      layout: "adminSidebar",
      menu: "vendor_entity",
      breadcrumbs: (to: RouteLocationNormalized, router: Router) => {
        return [
          { path: router.resolve({ name: vendorRouteName.index }).path, title: "Vendor" },
          { path: router.resolve({ name: vendorRouteName.show, params: { id: to.params.vendorId as string } }).path, title: "Detail" },
          { title: "User Detail" },
        ];
      },
    },
  },
];
